export const menuItems = [
    {
        label: "Dashboard",
        icon: "mdi mdi-apps",
        perm: "view_dashboard",
        link: "/"
    },
    {
        label: "POS",
        icon: "mdi mdi-store-outline",
        perm: "view_dashboard",
        link: "/pos"
    },
    {
        label: "Sales",
        icon: "bx-money",
        perm: "view_dashboard",
        link: "/myvisitors"
    },
    {
        label: "Inventory",
        icon: "mdi mdi-shopping",
        perm: "view_dashboard",
        subItems: [
            {
                label: "Stock levels",
                perm: "view_dashboard",
                link: "/stocklevels",
            },
            {
                label: "Add New Stock",
                perm: "view_dashboard",
                link: "/addstock",
            },
            {
                label: "Product Items",
                perm: "view_dashboard",
                link: "/productitems",
            },
            {
                label: "Product Item Units",
                perm: "view_dashboard",
                link: "/productitemunits",
            },
            {
                label: "Product Categories",
                perm: "view_dashboard",
                link: "/productcategories",
            },
            {
                label: "Product Units",
                perm: "view_dashboard",
                link: "/productunits",
            },
            {
                label: "Suppliers",
                perm: "view_dashboard",
                link: "/suppliers",
            },
        ]
    },
    {
        label: "Expenses",
        icon: "mdi mdi-database",
        perm: "view_dashboard",
        subItems: [
            {
                label: "Record Expense",
                perm: "view_dashboard",
                link: "/recordexpense",
            },
            {
                label: "View Expenses",
                perm: "view_dashboard",
                link: "/viewexpenses",
            },
            {
                label: "Expense Items",
                perm: "view_dashboard",
                link: "/expenseitems",
            },
            {
                label: "Expense Categories",
                perm: "view_dashboard",
                link: "/expensecategories",
            },
        ]
    },
    {
        label: "Reports",
        icon: "mdi mdi-clipboard-list",
        perm: "view_dashboard",
        subItems: [
            {
                label: "Orders Report",
                perm: "view_dashboard",
                link: "/visits",
            },
            {
                label: "Payments Report",
                perm: "view_dashboard",
                link: "/visitors",
            },
            {
                label: "Purchases Reports",
                perm: "view_dashboard",
                link: "/visits",
            },
            {
                label: "Expenses Reports",
                perm: "view_dashboard",
                link: "/visits",
            },
            {
                label: "Monthy Analysis",
                perm: "view_dashboard",
                link: "/visitors",
            },
            {
                label: "Income & Expenditure",
                perm: "view_dashboard",
                link: "/visitors",
            },
        ]
    },
    {
        label: "Settings",
        perm: "view_dashboard",
        icon: "mdi mdi-cog",
        subItems: [
            {
                label: "System Users",
                perm: "view_dashboard",
                link: "/users",
            },
            {
                label: "System Roles",
                perm: "view_dashboard",
                link: "/roles",
            },
            {
                label: "System Permissions",
                perm: "view_dashboard",
                link: "/permissions",
            },
            {
                label: "Payment Methods",
                perm: "view_dashboard",
                link: "/paymentoptions",
            },
            {
                label: "Company Profile",
                perm: "view_dashboard",
                link: "/profile",
            },
        ]
    },
];